import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { IUserResponse } from '../../interfaces/user.interface';
import { StorageService } from '../../../../core/services/storage/storage.service';
import { HairdressersService } from '../../../../shared/services/hairdressers/hairdressers.service';
import { map, catchError, of } from 'rxjs';

/**
 * Guard qui protège la page d'onboarding.
 * Si le coiffeur a déjà des services, il est redirigé vers son salon.
 * Empêche l'accès à l'onboarding si les services sont déjà configurés.
 */
export const noServicesGuard: CanActivateFn = (_route, _state) => {
    const router: Router = inject(Router);
    const storageService = inject(StorageService);
    const hairdressersService = inject(HairdressersService);

    const user: IUserResponse | null = storageService.getObject<IUserResponse>('USER');

    // Si pas d'utilisateur ou pas un coiffeur, rediriger vers home
    if (!user || user.user_type !== 'hairdresser') {
        router.navigate(['/home']);
        return false;
    }

    // Vérifier si le coiffeur a des services via l'API
    return hairdressersService.getHairdresserServices(user.id).pipe(
        map(response => {
            const hasServices = response?.listCoiffure && response.listCoiffure.length > 0;

            if (hasServices) {
                // A déjà des services, rediriger vers le salon
                router.navigate(['/hairdresser/salon']);
                return false;
            }

            // Pas de services, permettre l'accès à l'onboarding
            return true;
        }),
        catchError(() => {
            // En cas d'erreur API, permettre l'accès à l'onboarding
            return of(true);
        })
    );
};
